import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Box, TextField, Button } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";
import { useAuth } from "../../context/AuthContext";

const LoginPage = () => {
const [email, setEmail] = React.useState("");
const [password, setPassword] = React.useState("");
const [error, setError] = React.useState("");
const { user, currentUserData, rol, authLoading } = useAuth();


  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      //console.log("✅ Login exitoso, esperando datos de usuario...");
    } catch (err) {
      setError("Credenciales inválidas o error de red");
    }
  };

  useEffect(() => {
    // Comment: redirect only after auth finished resolving
    if (!authLoading && user && currentUserData && rol) {
      navigate("/");
    }
  }, [authLoading, user, currentUserData, rol, navigate]);

  if (authLoading) {
    // Comment: global loading while Firebase resolves current session
    return (
      <Container maxWidth="xs">
        <Box mt={10} display="flex" justifyContent="center">
          <Typography>Cargando datos del usuario...</Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xs">
      <Box mt={0} display="flex" flexDirection="column" alignItems="center">
        <img
          src="https://nataonline.com/wp-content/uploads/2024/02/6.jpg"
          alt="Logo"
          style={{ height: 260, marginBottom: 5 }}
        />
        <Typography variant="h5">Iniciar Sesión</Typography>
        <Box component="form" onSubmit={handleLogin} mt={2} width="100%">
          <TextField
            label="Email"
            type="email"
            fullWidth
            required
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            required
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
            Ingresar
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default LoginPage;